import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorImage from '../../assets/images/error.png';
import { GIFT_CARD_CART, LINK_HOME } from '../../devUtils/constants';
import { logErrorToService } from '../services/serviceHandler';
import Button from '../../components/Button';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logErrorToService(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center">
          <h1 className="text-center error-page">
            <img src={ErrorImage} alt="" />
            <br />
            Oops! Something went wrong.
          </h1>
          <Button type="primary" onClick={() => window.location.replace(LINK_HOME)}>Take me Home</Button>
          <Button type="primary" onClick={() => window.location.replace(GIFT_CARD_CART)}>Take me to Cart</Button>
        </div>);
    }
    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};
export default ErrorBoundary;



// WEBPACK FOOTER //
// client/config/components/ErrorBoundry.js